<template>
  <section class="catalog-look-modal">
    <ModalAsideHeader> {{ result.title }} </ModalAsideHeader>
    <ModalAsideBody>
      <div class="catalog-look-modal__products">
        <SliderCard
          v-for="item in result.items"
          :key="(item.offer && item.offer.id) || item.id"
          :result="item"
        />
      </div>
    </ModalAsideBody>
  </section>
</template>

<script setup lang="ts">
import SliderCard from '@components/card/SliderCard/SliderCard.vue';
import ModalAsideHeader from '@use/useModalAside/ModalAsideHeader.vue';
import ModalAsideBody from '@use/useModalAside/ModalAsideBody.vue';

const props = defineProps(['result']);
</script>

<style lang="scss" scoped>
.catalog-look-modal {
  display: flex;
  flex-direction: column;
  &__products {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-gap: 8px;
    overflow-y: auto;
    padding-right: 10px;
    @include point-md {
      grid-gap: 12px;
    }
    @include point-lg {
      grid-gap: 12px;
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
}
</style>
